module.exports = __webpack_public_path__ + "media/images/email-b6d1231edc06a02ee711f2482c216a09.png";